import { PageEntitiesEdit } from './Edit';
import { PageEntities } from './Overview';
import { PageRootEntity } from './RootEntity';
import { PageRootEntitySection } from './RootEntitySection';

export const ENTITIES = {
  Entities: PageEntities,
  EntitiesEdit: PageEntitiesEdit,
  RootEntity: PageRootEntity,
  RootEntitySection: PageRootEntitySection,
} as const;
